import React from 'react'
import { keys } from 'lodash'
import classNames from 'classnames'
import MediaQuery from 'react-responsive'
import { withRouter } from 'react-router-dom'
import { pure } from 'recompose'
import { connect } from 'react-redux'
import withStyles from 'material-ui-next/styles/withStyles'
import Button from 'material-ui-next/Button'
import Icon from 'material-ui-next/Icon'
import { getTopBarConfig } from '../../selectors'
import { uiConfigureTopBar } from '../../actions'
import breakpoints from '../../styles/breakpoints'
import { parseQ, parseQsGenere, makeParseQsAttributesMem } from '../../utils'
import { getDistrictFilter } from '../../selectors'

const styles = theme => ({
  filterIcon: {
    paddingRight: 3,
    [`@media (max-width: ${breakpoints.xs})`]: {
      paddingRight: 0,
    },
  },
  filterLabel: {
    fontSize: 14,
    [`@media (max-width: ${breakpoints.xs})`]: {
      display: 'none',
    },
  },
  filterButton: {
    paddingRight: 0,
    paddingLeft: 0,
    minWidth: 0,
    backgroundColor: 'transparent',
    color: theme.swapick.colors.energized,
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.swapick.colors.primary,
    },
    '&.active': {
      color: theme.swapick.colors.secondary,
    },
    '&.active': {
      color: theme.swapick.colors.secondary,
      '&:hover': {
        backgroundColor: 'transparent',
        color: theme.swapick.colors.primary,
        // On mobile always fucking colored touching hover ripple bug...
        [`@media (max-width: ${breakpoints.xs})`]: {
          color: theme.swapick.colors.secondary,
        },
      },
    },
  },
})

const FilterButton = ({
  openFilters,
  filtersActive,
  searchActive,
  classes,
  uiConfigureTopBar,
}) => (
  <MediaQuery maxWidth={breakpoints.xs}>
    {isMobile => {
      const activeButton = isMobile
        ? filtersActive || searchActive
        : filtersActive
      return (
        <Button
          onClick={() => uiConfigureTopBar({ openFilters: !openFilters })}
          className={classNames(classes.filterButton, {
            active: activeButton,
          })}>
          <Icon className={classes.filterIcon}>filter_list</Icon>
          <span className={classes.filterLabel}> Filtra</span>
        </Button>
      )
    }}
  </MediaQuery>
)

const parseQsAttributesMem = makeParseQsAttributesMem()

const mapStateToProps = (state, ownProps) => {
  const { openFilters } = getTopBarConfig(state)

  const filtersActive =
    parseQsGenere(ownProps.location) !== '' ||
    getDistrictFilter(state, ownProps.location) !== '' ||
    keys(parseQsAttributesMem(ownProps.location)).length > 0

  const searchActive = parseQ(ownProps.location) !== ''

  return {
    openFilters,
    filtersActive,
    searchActive,
  }
}

export default withRouter(
  withStyles(styles)(
    connect(mapStateToProps, {
      uiConfigureTopBar,
    })(pure(FilterButton))
  )
)



// WEBPACK FOOTER //
// ./src/common/TopBar/FilterButton.js